import React from 'react';

const ServicesSection = () => {
  const services = [
    {
      title: '0→1 Journeys',
      description: 'From concept to market-ready product. I help startups and established companies launch new products from scratch, focusing on market validation, MVP development, user research, and product-market fit.',
      image: '/images/product-launch.png'
    },
    {
      title: 'GTM Strategy',
      description: 'Most startups struggle to find who their real customer is and how to reach them. I help founders identify the right segments, position their product effectively, and build distribution channels that actually move the needle.',
      image: '/images/target.png'
    },
    {
      title: 'Empowered Product Teams',
      description: 'Too many product managers just take orders - they don’t solve problems. I build empowered teams that own outcomes, make decisions with context and consistently deliver meaningful impact.',
      image: '/images/leadership.png'
    }
  ];

  return (
    <section id="services" className="py-20 px-4 bg-gray-100">
      <div className="w-full lg:max-w-7xl lg:mx-auto">
        <h2 className="text-4xl lg:text-6xl font-bold text-center mb-16">how I can help you</h2>
        
        {/* Desktop: 3 Column Grid */}
        <div className="hidden md:grid md:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div key={index} className="card bg-gray-50 p-6 text-center">
              <div className="flex justify-center mb-4">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-32 h-32 max-w-32 max-h-32 object-cover rounded-lg"
                />
              </div>
              <h3 className="text-xl font-extrabold mb-3 text-black">{service.title}</h3>
              <p className="text-sm font-light leading-relaxed text-base-content/80">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* Mobile: 4 Row Layout */}
        <div className="block md:hidden space-y-4">
          {services.map((service, index) => (
            <div key={index} className="card bg-gray-50 p-4 flex flex-row items-start">
              <div className="mr-4 flex-shrink-0">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-16 h-16 max-w-16 max-h-16 object-cover rounded-lg"
                />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-extrabold mb-2 text-black">{service.title}</h3>
                <p className="text-sm font-light leading-relaxed text-base-content/80">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection; 